module.exports = __webpack_public_path__ + "media/images/logos/PASS-913fba2c7a668c801cfe62788fc6c960.png";